import { parse } from 'date-fns';

export const convertStrToDate = (dateString: string, format: string) =>
  parse(dateString, format, new Date());
